import {FormGroup, TextField,  Button} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState} from "react";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { v4 as uuidv4 } from 'uuid';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Test = () => {
    const classes = useStyles();
    //const [count, setcount]=useState([])
    const [data, setdata]=useState([])

    const addcount =() =>{
        //console.log(count)
        //setcount([...count, Math.random()])
        //setcount(count.length ==0 ? [Math.random()] : [...count, Math.random()])
        setdata(data.length==0? [{id:uuidv4()}]: [...data,{id:uuidv4()}])
        // console.log(data)
        // console.log(count)
    }

    const removecount =() =>{
        //console.log(count)
        //setcount([...count].slice(0,count.length-1))
        setdata([...data].slice(0,data.length-1))
        //console.log(count)
    }

    const savepdf =() =>{
        const input = document.getElementById('divToPrint');
        html2canvas(input)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF();
          pdf.addImage(imgData, 'JPEG', 0, 0);
          // pdf.output('dataurlnewwindow');
          pdf.save("download.pdf");
      })
    }

    const namechange =(e,tid) =>{
        
        //console.log(tid)
        //console.log(e)
        const newdata=data[tid]
        //console.log(newdata)
        const newitem= {...newdata, name:e.target.value}
        //console.log(newitem)
        data[tid]=newitem
        setdata(data)
        //setdata([...data, data[tid]=newitem])
        console.log(data)
    }
    
    const agechange =(e, tid) =>{
        //console.log(tid)
        //console.log(e)
        const newdata=data[tid]
        //console.log(newdata)
        const newitem= {...newdata, age:e.target.value}
        //console.log(newitem)
        data[tid]=newitem
        setdata(data)
        //setdata([...data, data[tid]=newitem])
        console.log(data)
    }
        //console.log(count)
        // backgroundColor: '#f5f5f5',
        // width: '210mm',
        // minHeight: '297mm',
        // marginLeft: 'auto',
        // marginRight: 'auto'
    //console.log(count)
    console.log(data)
    return (  
        <div id="divToPrint">
            {data.map(item => {
                return <div>
                <TextField variant="standard"  id={data.indexOf(item)} label="Name"  value={item.name} className={classes.textField} onChange={(e) => namechange(e,e.target.id)} />
                <TextField variant="standard"  label="Age"  id={data.indexOf(item)} value={item.age} className={classes.textField} onChange={(e) => agechange(e,e.target.id)} />
                </div>
            })}
            
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary"  className={classes.button} onClick={addcount}>Add</Button>
                <Button variant="contained" color="secondary" className={classes.button} onClick={removecount}>Remove</Button>
                <Button variant="contained" color="secondary" className={classes.button} onClick={savepdf}>PDF</Button>
            </FormGroup>
        </div>
    );
}
 
export default Test;

// <html>

// <head>
//     <title>jsPDF</title>
//     <script type="text/javascript" src="lib/jquery.min.js"></script>
//     <script type="text/javascript" src="lib/jspdf.debug.js"></script>
//     <script type="text/javascript" src="lib/html2canvas.js"></script>
//     <script>
// 	var pdf,page_section,HTML_Width,HTML_Height,top_left_margin,PDF_Width,PDF_Height,canvas_image_width,canvas_image_height;
	
	
	
// 	function calculatePDF_height_width(selector,index){
// 		page_section = $(selector).eq(index);
// 		HTML_Width = page_section.width();
// 		HTML_Height = page_section.height();
// 		top_left_margin = 15;
// 		PDF_Width = HTML_Width + (top_left_margin * 2);
// 		PDF_Height = (PDF_Width * 1.2) + (top_left_margin * 2);
// 		canvas_image_width = HTML_Width;
// 		canvas_image_height = HTML_Height;
// 	}
	



//     //Generate PDF
//     function generatePDF() {
//         pdf = "";
// 		$("#downloadbtn").hide();
// 		$("#genmsg").show();
//         html2canvas($(".print-wrap:eq(0)")[0], { allowTaint: true }).then(function(canvas) {

//             calculatePDF_height_width(".print-wrap",0);
//             var imgData = canvas.toDataURL("image/png", 1.0);
// 			pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
//             pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, HTML_Width, HTML_Height);

//         });

//         html2canvas($(".print-wrap:eq(1)")[0], { allowTaint: true }).then(function(canvas) {

//             calculatePDF_height_width(".print-wrap",1);
			
//             var imgData = canvas.toDataURL("image/png", 1.0);
//             pdf.addPage(PDF_Width, PDF_Height);
//             pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, HTML_Width, HTML_Height);

//         });

//         html2canvas($(".print-wrap:eq(2)")[0], { allowTaint: true }).then(function(canvas) {

//             calculatePDF_height_width(".print-wrap",2);
			
//             var imgData = canvas.toDataURL("image/png", 1.0);
//             pdf.addPage(PDF_Width, PDF_Height);
//             pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, HTML_Width, HTML_Height);


           
//                 //console.log((page_section.length-1)+"==="+index);
//                 setTimeout(function() {

//                     //Save PDF Doc	
//                     pdf.save("HTML-Document.pdf");

//                     //Generate BLOB object
//                     var blob = pdf.output("blob");

//                     //Getting URL of blob object
//                     var blobURL = URL.createObjectURL(blob);

//                     //Showing PDF generated in iFrame element
//                     var iframe = document.getElementById('sample-pdf');
//                     iframe.src = blobURL;

//                     //Setting download link
//                     var downloadLink = document.getElementById('pdf-download-link');
//                     downloadLink.href = blobURL;

// 					$("#sample-pdf").slideDown();
					
					
// 					$("#downloadbtn").show();
// 					$("#genmsg").hide();
//                 }, 0);
//         });
//     };

//     </script>
//     <style>
//     .print-wrap {
//         width: 500px;
//     }
//     </style>
// </head>

// <body>
//     <iframe frameBorder="0" id="sample-pdf" style="right:0; top:53px; bottom:0; height:400px; width:100%"></iframe>
//     <a id="pdf-download-link" title="Download PDF File">Download PDF file</a>
//     <a id="pdf-showiFrame-link" title="Show PDF in iFrame">Show PDF in iFrame</a>
//     <div class="print-wrap page1">
//         <h3>Sample page one for demo</h3>
//     </div>
//     <div class="print-wrap page2">
//         <h3>Sample page two for demo</h3>
//     </div>
//     <div class="print-wrap page3">
//         <h3>Sample page three for demo</h3>
//     </div>
// </body>

// </html>